import React from "react";
import { IInvoice } from "../../interfaces/IInvoice";
import { IInvoiceState } from "../../interfaces/IInvoiceState";
import { Chip, ChipOwnProps, ChipPropsColorOverrides, Color } from "@mui/material";

interface IProps {
    invoice: IInvoice;
    invoiceState: IInvoiceState[];
}

export const InvoiceStateChip: React.FC<IProps> = ({
    invoice,
    invoiceState
}) => {
    const currentState = invoiceState.find(state =>
        state.id === invoice.InvoiceState
    )
    const currentColor: "success" | "info" | "error" | "default" | "primary" | "secondary" | "warning" =
        [30, 50, 51].includes(invoice.InvoiceState) ? "success"
        : invoice.InvoiceState === 20 ? "info"
        : invoice.InvoiceState === 40 ? "error"
            : "default"
    ;
    const currentVariant: "filled" | "outlined" = 
        ( [50,51,60,70].includes(invoice.InvoiceState ) ) ? "filled"
        : "outlined"
    ;

    if (!currentState) {
        return <Chip color="error"  variant="filled" label="Fehler!" />
    }

    return(
        <Chip
            color={currentColor}
            variant={currentVariant}
            label={currentState.invoiceState}
        />
    )

}